<template>
  <div class="content-wrap content-size">
    <div class="error-page">
      <div class="in-error-page">
        <div class="in-in-error-page">
          <br />
          <br />
          <h2>{{ titulo }}</h2>
          <h3>{{ $t('NaoEncontrado') }}</h3>
          <br />
          <br />
          <p>Infelizmente não encontramos o {{ titulo }}</p>
          <p>Verifique o link digitado e tente novamente.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound",
  props: {
    titulo: String
  }
};
</script>

<style>
</style>